import React from 'react';
import { Divider, Typography, Box } from 'vindi-ds-components';
import { VdAlertCircle } from 'vindi-ds-icons/vd';

function FormHeader() {
  return (
    <Box mb='1rem'>
      <Box mb='1rem' alignItems='center' display='flex'>
        <Box mr='1rem'>
          <VdAlertCircle size='3rem' color='#FAD246' />
        </Box>
        <Typography component='h1' variant='h5'>
          Não perca informações importantes!
        </Typography>
      </Box>
      <Box mb='1rem'>
        <Divider />
      </Box>
      <Typography paragraph component='p' variant='body1'>
        Mantenha seus dados cadastrais atualizados e fique por dentro das
        principais novidades e comunicações para ter a melhor expêriencia na
        Vindi
      </Typography>
    </Box>
  );
}

export default FormHeader;
